<template>
  <div class="postSetting">
    <el-container>
      <el-header>
        <el-row>
          <el-form ref="postform" :model="postform" label-width="60px" :inline="true">
            <el-col :span="6">
              <el-form-item label="字典名称" prop="name">
                <el-input v-model="postform.name" placeholder="-请输入-"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="所属组织">
                <el-select v-model="postform.groupId">
                  <el-option v-for="sys in GovList" :key="sys.id" :label="sys.name" :value="sys.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>-->
          </el-form>
          <el-col :span="6" style="text-align:right;">
            <div class="handlePanel">
              <el-button type="primary" @click="selectBtnPressed()">查询</el-button>
              <el-button type="info" @click="resetBtnPressed()">重置</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align:right;">
            <div class="operatePanel">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="addBtnPressed()"
                v-if="btnAuthorize.addBtn.btnEnable"
              >新增</el-button>
              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="updBtnPressed()"
                v-if="btnAuthorize.modifyBtn.btnEnable"
              >修改</el-button>
              <el-button
                type="primary"
                icon="el-icon-delete"
                @click="delBtnPressed()"
                v-if="btnAuthorize.delBtn.btnEnable"
              >删除</el-button>
            </div>
          </el-col>
        </el-row>
        <!-- <div style="clear:both;"></div> -->
      </el-header>
      <el-main ref="main">
        <el-table
          :data="postionList"
          highlight-current-row
          height="100%"
          size="mini"
          @current-change="handleSelectionChange"
          border
        >
          <el-table-column prop="id" label="编号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="name" label="字典名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="details" label="详细信息" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="BasicDataDetail(scope.row)" type="text" size="small">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="postform.pageIndex"
          :page-sizes="[10,20, 30, 40,50]"
          :page-size="postform.pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <!-- 新增/修改弹窗 -->
    <el-dialog
      class="dialog816"
      :title="isAdd?'新增数据字典':'修改数据字典'"
      :visible.sync="isAddDialogShow"
      width="32%"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="160px" :rules="addRules" ref="addForm">
        <el-row>
          <el-col :span="20">
            <el-form-item label="字典名称" prop="name">
              <el-input v-model="addForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="父级字典">
              <el-select v-model="addForm.pid">
                <el-option
                  :label="bdata.name"
                  :value="bdata.id"
                  v-for="bdata in postionListsub"
                  :key="bdata.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="addForm.remark"  type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="isAddDialogShow=false">取 消</el-button>
        <el-button type="primary" @click="saveBtnPressed()">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  BasicDataService, //获取数据字典列表
  BasicDataDetailsService, //获取数据字典详情
  insertBasicDataService, //新增数据字典
  modifyBasicDataService, //修改数据字典
  deleteBasicDataService, //删除数据字典
  getEditRolesByUserCodeService, //获取角色列表
  getGovService //组织列表
} from "../../services/sysSettingService";
export default {
  name: "postSetting",
  data() {
    return {
      total: 0, //字典列表总数
      postionList: [], //字典列表
      postionListsub:[],// 可以添加二级字典的字典详情
      deptList: [], //可选组织列表
      roleList: [], //角色列表
      isAddDialogShow: false, //新增字典弹窗显示开关
      isAdd: true, //新增/修改字典标识
      postSelected: null, //选中的字典
      postform: {
        name: "",
        // roleId: "", //所属角色
        // deptId: "", //所属部门
        pageIndex: 1,
        pageSize: 10
      },
      addForm: {
        name: "",
        pid: "", //父级字典
        remark: "" //备注
      },
      addRules: {
        name: [
          { required: true, message: "请输入字典名称", trigger: "blur" },
          {
            min: 1,
            max: 9,
            message: "输入内容长度必须介于1到9之间",
            trigger: "blur"
          }
        ],
        pid: [
          // { min: 1, max: 5, message: "输入内容长度必须介于1到5之间" },
          {
            pattern: /(^[0-9]\d*$)/,
            message: "输入内容必须为大于等于0的正整数",
            trigger: "blur"
          }
        ],
        remark: [
          {
            min: 1,
            max: 100,
            message: "输入内容长度必须介于1到100之间",
            trigger: "blur"
          }
        ]
      },
      //按钮权限
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false }
      }
    };
  },
  props: {
    menuCode: {
      type: String
    }
  },
  methods: {
    //激活时调用
    onActive(menuCode) {
      if (this.$refs.postform) {
        this.$refs.postform.resetFields();
        this.postform.pageIndex = 1;
        this.postform.pageSize = 20;
      }
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      // this.getUserOneLevelDept();
      // this.getUserOneLevelRole();
      this.manangerStation();
      
    },
    /* 获取数据字典列表 */
    manangerStation() {
      // this.postform.userCode = sessionStorage.getItem("userCode");
      this.postform.pid=0;
      BasicDataService(this.postform).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.total = res.total;
            this.postionList = res.data;
             this.manangerStationsub();
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
      /* 获取数据字典列表 */
    manangerStationsub() {
      let param={
        sid:0,
        pid:0,
        pageIndex:1,
        pageSize:-1
      }
      // this.postform.userCode = sessionStorage.getItem("userCode");
      // this.postform.sid=0;
      BasicDataService(param).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.postionListsub = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 获取字典详情 */
    stationDetails(postCode) {
      let reqParam = {
        postCode: postCode
      };
      BasicDataDetailsService(reqParam).then(
        res => {
          console.log(res);
          if (res.resultCode == 0) {
            this.addForm = res.data;
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    insertStation() {
      // this.addForm.userCode = sessionStorage.getItem("userCode");
      insertBasicDataService(this.addForm).then(
        res => {
           console.log(res);
          if (res.code == 10000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
            this.isAddDialogShow = false;
            this.manangerStation();
          } else if(res.code >= 20000000)
          {
             this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });

          } else{
             this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
        }
      );
    },
    /* 修改字典信息 */
    modifyStation() {
      // this.addForm.userCode = sessionStorage.getItem("userCode");
      modifyBasicDataService(this.addForm).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
            this.isAddDialogShow = false;
            this.manangerStation();
          } else if(res.code >= 20000000)
          {
             this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });

          } else{
             this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
        }
      );
    },
    /* 分页改变事件 */
    handleCurrentChange(page) {
      console.log(page);
      this.postform.pageIndex = page;
      this.manangerStation();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.postform.pageSize = rows;
      this.postform.pageIndex = 1;
      this.manangerStation();
    },

    /* 查询按钮回调 */
    selectBtnPressed() {
      this.manangerStation();
    },
    /* 重置按钮回调 */
    resetBtnPressed() {
      this.$refs.postform.resetFields();
    },
    /* 新增按钮回调 */
    addBtnPressed() {
      this.isAdd = true;
      this.isAddDialogShow = true;
     
        this.addForm.name = "";
        this.addForm.pid = "";
        this.addForm.remark = "";
      
    },
    /* 修改按钮回调 */
    updBtnPressed() {
      if (this.postSelected == null) {
        this.$alert("请选择一条要修改的记录！", "错误");
      } else {
        this.isAdd = false;
        this.isAddDialogShow = true;
        this.addForm.name = this.postSelected.name;
        this.addForm.pid = this.postSelected.pid;
        this.addForm.remark = this.postSelected.remark;
      }
    },
    /* 删除按钮回调 */
    delBtnPressed() {
      if (this.postSelected == null) {
        this.$alert("请选择一条要修改的记录！", "错误");
      } else {
        this.$confirm("确定删除数据字典?", "提示").then(() => {
          let params = {
            dictId: this.postSelected.id
          };
          deleteBasicDataService(params).then(
            res => {
              console.log(res);
              if (res.code == 10000000) {
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.manangerStation();
              } else {
                this.$alert(res.msg, "提示");
              }
            },
            err => {
              this.$alert(err, "错误", {
                confirmButtonText: "确定"
              });
            }
          );
        });
      }
    },
    /* 弹窗保存按钮回到 */
    saveBtnPressed() {
      this.$refs.addForm.validate(res => {
        if (res) {
          if (this.isAdd) {
            this.insertStation();
          } else {
            this.modifyStation();
          }
        }
      });
    },

    /* 列代表单选回调 */
    handleSelectionChange(post) {
      this.postSelected = post;
      this.addForm.id = post.id;
      // if (post != null) {
      //   this.$nextTick(() => {
      //     this.addForm = Object.assign({}, post);
      //   });
      // }
    },
    /* 获取新增角色时可选组织 */
    getUserOneLevelDept() {
      let reqParam = {
        pageIndex: 1,
        pageSize: 100
      };
      getGovService(reqParam).then(
        res => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.GovList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },
    //getUserOneLevelRole
    getUserOneLevelRole() {
      let reqParam = {
        pageIndex: 1,
        pageSize: 100
      };
      getEditRolesByUserCodeService(this.reqParam).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            // this.total = res.total;
            this.roleList = res.data;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },

    //跳转到字典详情页面
    BasicDataDetail(row) {
      this.bus.$emit("navMenuChange", {
        routeId: "crontabSetting", //跳转到数据字典详情页
        routeParam: {
          dictId: row.id,
          sid: row.sid, //有二级数据字典
          colName: row.name, //字典名称
          routeId: "order-detail"
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.postSetting {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
/deep/.el-form-item__label {
  text-align: right;
}
.el-footer {
  text-align: right;
}
/deep/.el-dialog {
  .el-select {
    width: 100%;
  }
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>
